<template>
  <div v-if="field && field.value.text" class="right-top-cta">
    <sc-link :field="field" class="c-cta--primary" />
  </div>
</template>

<script>
import { Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-CTA',
  components: {
    ScLink: Link
  },
  props: {
    field: {
      type: Object
    }
  }
};
</script>
<style lang="scss">
@import '~@/assets/scss/components/cta.scss';
</style>
